import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImagePreviewService {
  readonly url   = signal<string | null>(null);
  readonly label = signal('');

  open(url: string, label = '') {
    this.url.set(url);
    this.label.set(label);
  }

  close() {
    this.url.set(null);
  }
}
